import { useMemo } from 'react';
import { getPreviewComponentByAssetType } from '../preview_component_mapping';
const NullComponent = () => null;
export const usePreviewComponent = (previewOptions, productVersion = '', fallback = NullComponent) => {
    const previewId = previewOptions === null || previewOptions === void 0 ? void 0 : previewOptions.id;
    return useMemo(() => {
        if (!previewId) {
            return fallback;
        }
        const previewComponent = getPreviewComponentByAssetType(productVersion, previewId);
        return previewComponent !== null && previewComponent !== void 0 ? previewComponent : fallback;
    }, [previewId, productVersion, fallback]);
};
//# sourceMappingURL=use_preview_component.js.map